import mock from './mock';

import './pages/faq';
import './pages/knowledge-base';
import './server-side-menu/vertical';
import './server-side-menu/horizontal';
import './addons/modules';
import './addons/offers';
import './uiflow';
import './uiflow/users';
import './uiflow/companies';
import './workflow';
import './components/vigo-datagrid/userList';
import './components/vigo-address/fieldsByCountry';
import './components/vigo-address/addressSearch';
import './components/vigo-datatable/userDetailList';
import './dashboard/index';
import './uiflow/newsfeed';
import './pages/tracking';
import './uiflow/routeOptimiser';

mock.onAny().passThrough();
